<template>
  <div :class="bootstrapClass">
    <div v-if="title === 'cancellations' || title === 'returns'" :class="'box box-' + type + ' box-solid collapsed-box'">
      <div class="box-header no-border">
        <h3 class="box-title">
          {{title | translate}}
        </h3>
        <div v-if="items.channels.length !== 0" class="box-tools pull-right" title="Details einblenden">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i></button>
        </div>
      </div>
      <div :class="'info-box bg-'+ type + '-active no-margin'">
        <span class="info-box-icon"><i :class="['fa', icon]"></i></span>
        <div class="info-box-content">
          <template v-if="title === 'cancellations'">
            <span class="info-box-text">
              {{items.items}}
              {{'items' | translate}}
              -
              {{items.cancellations}}
              {{'cancellations' | translate}}
            </span>
            <span class="info-box-number">
              % {{items.percentage}}
            </span>
          </template>
          <template v-else>
            <span class="info-box-text">
              {{items.items}}
              {{'items' | translate}}
              -
              {{items.returns}}
              {{'returns' | translate}}
            </span>
            <span class="info-box-number">
              % {{items.percentage}}
            </span>
          </template>
        </div>
      </div>
      <div class="box-body" style="display: none;">
        <ul class="list-group list-group-unbordered">
          <template v-for="(item, name) in items.channels">
            <template v-if="title === 'cancellations'">
              <li class="list-group-item">
                <b>{{name | translate}} <small>({{item.items}} Stk.)</small>:</b> <span class="pull-right">{{item.cancellations}} <small>({{item.percentage}}%)</small></span>
              </li>
            </template>
            <template v-else>
              <li class="list-group-item">
                <b>{{name | translate}} <small>({{item.items}} Stk.)</small>:</b> <span class="pull-right">{{item.returns}} <small>({{item.percentage}}%)</small></span>
              </li>
            </template>
          </template>
        </ul>
      </div>
    </div>
    <div v-else :class="`box box-${type} box-solid collapsed-box`">
      <div class="box-header no-border">
        <h3 class="box-title">{{title | translate}}</h3>
        <small v-if="title === 'ranking' || 'tamaris_status'" class="text-muted"><a href="#" class="ml-5" data-toggle="modal" data-target="#ranking-modal">Info<i class="fa fa-info-circle ml-5"></i></a></small>
        <div class="box-tools pull-right" title="Details einblenden">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i></button>
        </div>
      </div>
      <div :class="`info-box bg-${type}-active no-margin`">
        <span class="info-box-icon"><i :class="['fa', icon]"></i></span>
        <div v-if="title === 'ranking' || 'tamaris_status'" class="info-box-content">
          <span class="info-box-text">
            <i :class="getIcon(items.status)"></i>
            {{items.status | translate}}
          </span>
          <span class="info-box-number">
            <span>{{'position' | translate}}: </span>
            {{items.position}}
          </span>
        </div>
        <div v-else class="info-box-content">
          <span class="info-box-text">
            {{items.items}}
            {{'items' | translate}}
          </span>
          <span class="info-box-number">
            {{items.orders}}
            <small> {{'orders' | translate}}</small>
          </span>
        </div>
      </div>
      <div v-if="title === 'ranking' || 'tamaris_status'" class="box-body" style="display: none;">
        <ul class="list-group list-group-unbordered">
          <li class="list-group-item" v-if="items && items.position">
            <b>{{'positioning' | translate}}:</b> <span class="pull-right">{{items.position}}</span>
          </li>
          <li class="list-group-item">
            <b>{{'ranking_base' | translate}}:</b> <span class="pull-right">{{items.ranking_base}}</span>
          </li>
          <li class="list-group-item">
            <b>{{'store_ranking' | translate}}:</b> <span class="pull-right">{{items.points - items.ranking_base}}</span>
          </li>
          <li class="list-group-item">
            <b>{{'rating_points' | translate}}:</b> <span class="pull-right">{{items.points}}</span>
          </li>
        </ul>
        <div class="row">
          <div v-if="title === 'ranking'" class="col-xs-12">
            <a v-if="csvUrl !== ''" :href="csvUrl" target="_blank" class="btn btn-success" @click="csvUrl = ''"><i :class="[loadingCSV ? 'fa fa-spinner fa-spin' : 'fa fa-cloud-download',  'mr-5']"></i>{{'csv_ready' | translate}}</a>
            <button v-else class="btn btn-warning" @click="downloadCsv" :disabled="loadingCSV"><i :class="[loadingCSV ? 'fa fa-spinner fa-spin' : 'fa fa-cloud-download',  'mr-5']"></i>{{'request_csv_download' | translate}}</button>
          </div>
          <div v-if="title === 'tamaris_status'" class="col-xs-12">
            <a v-if="csvUrlTamaris !== ''" :href="csvUrlTamaris" target="_blank" class="btn btn-success" @click="csvUrlTamaris = ''"><i :class="[loadingCSVTamaris ? 'fa fa-spinner fa-spin' : 'fa fa-cloud-download',  'mr-5']"></i>{{'csv_ready' | translate}}</a>
            <button v-else class="btn btn-warning" @click="downloadCsvTamaris" :disabled="loadingCSVTamaris"><i :class="[loadingCSVTamaris ? 'fa fa-spinner fa-spin' : 'fa fa-cloud-download',  'mr-5']"></i>{{'request_csv_download' | translate}}</button>
          </div>
        </div>
      </div>
      <div v-else class="box-body" style="display: none;">
        <ul class="list-group list-group-unbordered">
          <li class="list-group-item" v-if="items && items.average">
            <b>Ø {{'order_avg' | translate}}:</b> <span class="pull-right">{{items.average | currency}}</span>
          </li>
          <li class="list-group-item" v-if="items && items.amount">
            <b>{{'total_amount' | translate}}:</b> <span class="pull-right">{{items.amount | currency}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items', 'type', 'title', 'icon', 'bootstrapClass'],
  data () {
    return {
      pointsLink: {},
      timeSelector: this.title === 'returns' ? '30_days' : '7_days',
      loadingCSV: false,
      loadingCSVTamaris: false,
      csvUrlTamaris: '',
      csvUrl: ''
    }
  },
  methods: {
    getIcon (status) {
      switch (status) {
        case 'warning':
          return ['fa', 'fa-warning', 'mr-5']
        case 'success':
          return ['fa', 'fa-check', 'mr-5']
        case 'danger':
          return ['fa', 'fa-bolt', 'mr-5']
      }
    },
    downloadCsv () {
      this.loadingCSV = true
      API.get('/statistics/merchant-points')
        .then(response => {
          this.csvUrl = response.data.url
          this.loadingCSV = false
        })
        .catch(() => {
          this.$store.commit('pushAlert', {type: 'danger', dismiss: 4, message: 'Error!', icon: 'fa fa-ban', show: true})
          this.loadingCSV = false
        })
    },
    downloadCsvTamaris () {
      this.loadingCSVTamaris = true
      API.get('/statistics/merchant-points/tamaris')
        .then(response => {
          this.csvUrlTamaris = response.data.url
          this.loadingCSVTamaris = false
        })
        .catch(() => {
          this.$store.commit('pushAlert', {type: 'danger', dismiss: 4, message: 'Error!', icon: 'fa fa-ban', show: true})
          this.loadingCSVTamaris = false
        })
    }
  },
  mounted () {
  },
  watch: {
    items () {
      this.csvUrl = ''
    },
    timeSelector () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/PerformanceBoxComponent.vue